import React, { useState, useEffect, useRef } from 'react'
import { TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button, MenuItem, Card, CardMedia, CardActions, IconButton, Snackbar, Alert } from '@mui/material'
import { app, database, storage } from '../../../firebaseConfig'
import { addDoc, collection, query, orderBy, onSnapshot } from 'firebase/firestore'
import testImg from '../../../assets/testImg.png'
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import CloseIcon from '@mui/icons-material/Close'
import dateFormat, { masks } from "dateformat";

function AddService({ onClose, open, list }) {
    const [nom, setNom] = useState('')
    const [partie, setPartie] = useState('')
    const [description, setDescription] = useState('')
    const [photo, setPhoto] = useState({})
    const [photoDisplay, setPhotoDisplay] = useState(null)
    const inputFileRef = useRef(null)
    const [chus, setChus] = useState([])
    const [errorData, setErrorData] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    useEffect(() => {
        const q = query(collection(database, 'chu'), orderBy('nom_chu', 'asc'))
        onSnapshot(q, (querySnapshot) => {
            setChus(querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })))
        })
    }, [])
    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorData(false)
    }
    const clickImage = (e) => {
        e.preventDefault()
        if (inputFileRef.current) {
            inputFileRef.current.click();
        }
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!photo.name || nom == '' || partie == '' || description == '') {
            setErrorData(true)
            setErrorMessage(' Veuillez remplir les champs obligatoire!')
            return
        }
        const listFilter = list.filter((elem) => {
            return elem.nom_service.toLowerCase() == nom.toLocaleLowerCase()
        })
        if (listFilter.length > 0) {
            setErrorData(true)
            setErrorMessage(' Service déjà existe à notre base de données!')
            return
        }
        try {
            let urlImage = await uploadImage(photo)
            const service = await addDoc(collection(database, 'service'), {
                nom_service: nom,
                description_service: description,
                partie: partie,
                image_service: urlImage
            })
            const service_id = service.id
            chus.map(async (chu) => {
                await addDoc(collection(database, 'service_chu'), {
                    chu_id: chu.id,
                    service_id: service_id,
                    status: false
                })
            })
            onClose()
        } catch (err) {
            setErrorData(true)
            setErrorMessage('Veuillez verifier votre connexion internet ou contacter l\'administrateur!')
        }

    }
    const uploadImage = (fileParm) => {
        const nom_img = "srv_img_"+dateFormat(new Date(),'yyyymmddHHMMss')
        return new Promise((resolve, reject) => {
            const storageRef = ref(storage, nom_img)
            const uploadTask = uploadBytesResumable(storageRef, fileParm)
            uploadTask.on('state_changed', (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
                (error) => {
                    console.log(error.message)
                    reject(error);
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        console.log('File available at', downloadURL);
                        resolve(downloadURL);
                    }).catch((error) => {
                        console.log(error.message);
                        reject(error);
                    });
                }
            )
        })

    }
    const changeImage = (e) => {
        const file = e.target.files[0]
        setPhoto(file)
        const reader = new FileReader();

        reader.onload = () => {
            setPhotoDisplay(reader.result);
        };

        reader.readAsDataURL(file);
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DialogTitle sx={{ m: 0, p: 2 }}>Ajout service</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Card sx={{ maxWidth: 200 }}>
                        <CardMedia
                            style={{ objectFit: 'contain', marginTop: 1, height: 100 }}
                            image={photoDisplay ? photoDisplay : testImg}
                            title="green iguana"
                        />
                        <CardActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button size="small" onClick={clickImage}>Choisir une photo</Button>
                        </CardActions>
                    </Card>
                </div>
                <div >
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="nom_service"
                        name="service"
                        label="Service"
                        fullWidth
                        onChange={(e) => {
                            setNom(e.target.value)
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="Partie"
                        defaultValue=""
                        fullWidth
                        onChange={(e) => {
                            setPartie(e.target.value)
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    >
                        <MenuItem key="" value="">
                            Veuillez selectionner une partie
                        </MenuItem>
                        <MenuItem key="Tête" value="Tête">
                            Tête
                        </MenuItem>
                        <MenuItem key="Poitrine" value="Poitrine">
                            Poitrine
                        </MenuItem>
                        <MenuItem key="Ventre" value="Ventre">
                            Ventre
                        </MenuItem>
                        <MenuItem key="Bras" value="Bras">
                            Bras
                        </MenuItem>
                        <MenuItem key="Appareil Génital" value="Appareil Génital">
                            Appareil Génital
                        </MenuItem>
                        <MenuItem key="Particulier" value="Particulier">
                            Particulier
                        </MenuItem>
                    </TextField>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="description"
                        name="description"
                        label="Description"
                        fullWidth
                        onChange={(e) => {
                            setDescription(e.target.value)
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}

                    />
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="Image"
                        name="image"
                        label="Image"
                        fullWidth
                        onChange={changeImage}
                        type='file'
                        InputLabelProps={{
                            shrink: true,
                        }}
                        style={{ display: 'none' }}
                        inputRef={inputFileRef}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
                <Button variant='contained' color='success' onClick={handleSubmit}>Enregistrer</Button>
            </DialogActions>
            <Snackbar open={errorData} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert
                    onClose={handleCloseAlert}
                    severity="error"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {errorMessage}
                </Alert>
            </Snackbar>
        </Dialog>

    )
}

export default AddService